<template>
  <!-- Kit ClIcon: a 24-unit outline glyph, round caps (the app's
       cl_glyph.dart). `path` is the SVG path data. -->
  <svg
    class="cl-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color || 'currentColor'"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path :d="path" />
  </svg>
</template>

<script>
export default {
  name: "ClIcon",
  props: {
    path: { type: String, required: true },
    size: { type: Number, default: 16 },
    stroke: { type: Number, default: 1.9 },
    color: { type: String, default: null },
  },
};
</script>

<style scoped>
.cl-icon {
  display: block;
  flex-shrink: 0;
}
</style>
